import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Critical resource hints - minimize to essentials
if (typeof window !== 'undefined') {
  // Preconnect to CDN with high priority
  const preconnectCDN = document.createElement('link');
  preconnectCDN.rel = 'preconnect';
  preconnectCDN.href = 'https://cdn.magicpatterns.com';
  document.head.appendChild(preconnectCDN);
  // Preload LCP image with fetchpriority
  const preload = document.createElement('link');
  preload.rel = 'preload';
  preload.as = 'image';
  preload.href = 'https://cdn.magicpatterns.com/uploads/db55hm39pPvsCQxNyf8uNx/zumba_mockup_webp_sin_fondo.webp';
  preload.type = 'image/webp';
  preload.fetchPriority = 'high';
  document.head.appendChild(preload);
}
render(<App data-id="element-337" />, document.getElementById('root'));